import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  isLoadingSubject = new BehaviorSubject<boolean>(false);
  private readonly progressSubject = new BehaviorSubject<number>(0);
  public isLoading$ = this.isLoadingSubject.asObservable();
  public progress$ = this.progressSubject.asObservable();

  get isLoading() {
    return this.isLoadingSubject.value;
  }

  show() {
    this.isLoadingSubject.next(true);
  }

  hide() {
    this.isLoadingSubject.next(false);
    this.progressSubject.next(0);
  }

}